import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/kidopia-logo.svg";
import { useAuth } from "../context/AuthContext";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { FaUserCircle } from "react-icons/fa";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  /* Scroll effect */
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* Close menu when screen becomes desktop */
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* Toggle menu */
 const toggleMenu = () => {
  setMenuOpen(!menuOpen);
};
  const handleLogout = async () => {
    await signOut(auth);
    navigate("/");
  };

  return (
    <div className={`navbar ${scrolled ? "scrolled" : ""}`}>

      {/* LOGO */}
      <div className="navbar-logo">
        <Link to="/">
          <img src={logo} alt="Kidopia Logo" className="logo-img" />
        </Link>
      </div>

      {/* HAMBURGER */}
      <div className="hamburger" onClick={toggleMenu}>
        {menuOpen ? "✖" : "☰"}
      </div>

      {/* NAV LINKS */}
      <ul className={`navbar-links ${menuOpen ? "active" : ""}`}>

        <li>
          <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
        </li>

        <li>
          <Link to="/learningzone" onClick={() => setMenuOpen(false)}>
            Learning Zone
          </Link>
        </li>

        <li>
          <Link to="/braingames" onClick={() => setMenuOpen(false)}>
            Brain Games
          </Link>
        </li>

        <li>
          <Link to="/storyworld" onClick={() => setMenuOpen(false)}>
            Story World
          </Link>
        </li>

        <li>
          <Link to="/creativitystudio" onClick={() => setMenuOpen(false)}>
            Creativity Studio
          </Link>
        </li>

      </ul>

      {/* PROFILE SECTION */}
      <div className="nav-right">

        {currentUser ? (
          <div className="profile-section">

            <Link to="/profile" className="profile-link">
              <FaUserCircle size={28} />
            </Link>

            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>

          </div>
        ) : (
          <Link to="/login" className="profile-link">
            <FaUserCircle size={28} />
          </Link>
        )}

      </div>

    </div>
  );
};

export default Navbar;